import { exibirMensagem, exibirErros } from "componentes/mensagem/actions";
import { adicionarProcesso, buscarDependenciasEspecificas } from "paginas/processo/actions";
export const tramitar = (evento, history) => (dispatch, getState) => {
  evento.preventDefault();
  const {
    id,
    situacao,
    responsavel,
    tiposAlegacao
  } = getState().processo.processo;

  const dados = {
    id,
    situacao,
    responsavel,
    tiposAlegacao
  };

  const urlTramitacao = `/services/api/processos/${id}/tramitar`;

  fetch(urlTramitacao, {
    method: "put",
    headers: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(dados)
  })
    .then(res => res.ok ? res.json() : Promise.reject(res))
    .then(processo => {
      dispatch(exibirMensagem({ msg: "Tramitação realizada com sucesso", tipo: "success" }));
      dispatch(buscarDependenciasEspecificas(processo))
        .then(depOK => {
          dispatch(adicionarProcesso(processo));
          history.push(`/processo/${processo.id}/tramitar/${processo.situacao.descricao}`);
        })
        .catch(erros => Promise.reject(erros));
    })
    .catch(erros => dispatch(exibirErros(erros)));
}


// WEBPACK FOOTER //
// ./src/paginas/tramitacao/actions.js